export default __webpack_public_path__ + "locales/hy-AM/Files.json?hash=c7f9b76284b8f23dea6d64b6eabffc4e";